var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.44 20.1375H26.4075V14.4375C26.4255 12.1884 25.5502 10.024 23.9739 8.41957C22.3976 6.81514 20.2491 5.90177 18 5.87999C15.7522 5.90375 13.6056 6.81798 12.0309 8.42219C10.4562 10.0264 9.58199 12.1896 9.59998 14.4375V20.1375H7.58248V14.4375C7.56044 11.6478 8.64402 8.96284 10.5962 6.96987C12.5484 4.9769 15.2104 3.83809 18 3.80249C20.7909 3.83613 23.4548 4.97407 25.4086 6.96725C27.3624 8.96043 28.447 11.6465 28.425 14.4375L28.44 20.1375Z",
    fill: "url(#paint0_linear_2411_244)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.305 31.185C14.0983 31.1612 11.9909 30.2638 10.4446 28.6894C8.89825 27.1149 8.03896 24.9918 8.05497 22.785V20.8125H9.06747V22.785C9.05344 24.718 9.80536 26.5779 11.1588 27.958C12.5122 29.3382 14.3571 30.1263 16.29 30.15L16.305 31.185Z",
    fill: "url(#paint1_linear_2411_244)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04002 17.595V22.7025C5.03408 23.1716 5.12084 23.6372 5.29534 24.0727C5.46984 24.5082 5.72862 24.9049 6.05685 25.2401C6.38507 25.5753 6.77626 25.8423 7.20797 26.0259C7.63968 26.2096 8.10341 26.3061 8.57252 26.31V13.995C8.10376 13.9979 7.6402 14.0935 7.20853 14.2763C6.77687 14.4591 6.38561 14.7255 6.05729 15.0601C5.72897 15.3947 5.47007 15.7909 5.29548 16.2259C5.1209 16.661 5.03408 17.1263 5.04002 17.595Z",
    fill: "url(#paint2_linear_2411_244)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57251 13.995V26.31C9.04226 26.3071 9.50679 26.2113 9.93936 26.0281C10.3719 25.8449 10.764 25.578 11.093 25.2427C11.4221 24.9074 11.6815 24.5104 11.8565 24.0744C12.0314 23.6385 12.1185 23.1722 12.1125 22.7025V17.595C12.1195 17.1254 12.0331 16.659 11.8584 16.223C11.6837 15.787 11.4242 15.3901 11.0948 15.0552C10.7655 14.7203 10.373 14.4541 9.94 14.2721C9.50701 14.0901 9.04219 13.9959 8.57251 13.995Z",
    fill: "#114289"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.96 17.595V22.7025C30.9659 23.1716 30.8792 23.6372 30.7047 24.0727C30.5302 24.5082 30.2714 24.9049 29.9432 25.2401C29.6149 25.5753 29.2237 25.8423 28.792 26.0259C28.3603 26.2096 27.8966 26.3061 27.4275 26.31V13.995C27.8963 13.9979 28.3598 14.0935 28.7915 14.2763C29.2231 14.4591 29.6144 14.7255 29.9427 15.0601C30.271 15.3947 30.5299 15.7909 30.7045 16.2259C30.8791 16.661 30.9659 17.1263 30.96 17.595Z",
    fill: "url(#paint3_linear_2411_244)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4275 13.995V26.31C26.9577 26.3071 26.4932 26.2113 26.0606 26.0281C25.6281 25.8449 25.236 25.578 24.907 25.2427C24.5779 24.9074 24.3185 24.5104 24.1435 24.0744C23.9686 23.6385 23.8815 23.1722 23.8875 22.7025V17.595C23.8825 17.1259 23.9703 16.6605 24.1457 16.2254C24.3211 15.7903 24.5807 15.3941 24.9096 15.0596C25.2386 14.7251 25.6303 14.4589 26.0624 14.2762C26.4945 14.0935 26.9584 13.9979 27.4275 13.995Z",
    fill: "#114289"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1125 32.1975H16.815C16.3058 32.1975 15.8174 31.9953 15.4574 31.6352C15.0973 31.2751 14.895 30.7868 14.895 30.2775C14.895 29.7683 15.0973 29.28 15.4574 28.9199C15.8174 28.5598 16.3058 28.3575 16.815 28.3575H18.1125C18.6217 28.3575 19.1101 28.5598 19.4702 28.9199C19.8302 29.28 20.0325 29.7683 20.0325 30.2775C20.0325 30.7868 19.8302 31.2751 19.4702 31.6352C19.1101 31.9953 18.6217 32.1975 18.1125 32.1975Z",
    fill: "#114289"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2411_244",
    x1: 18.0111,
    y1: 3.80249,
    x2: 18.0111,
    y2: 20.1375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C91F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0054E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2411_244",
    x1: 12.1799,
    y1: 20.8125,
    x2: 12.1799,
    y2: 31.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C91F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0054E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2411_244",
    x1: 6.80613,
    y1: 13.995,
    x2: 6.80613,
    y2: 26.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C91F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0054E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2411_244",
    x1: 29.1939,
    y1: 13.995,
    x2: 29.1939,
    y2: 26.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C91F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0054E6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.0daa5416635585979e2015bad3203836.svg";
export { ForwardRef as ReactComponent };